<div class="spot-panel__list" *ngIf="data && data.items">
  <div class="spot-panel__item" *ngFor="let item of data.items">
    <div class="spot-panel__image">
      <app-video-element *ngIf="isVideo(item)" [data]="item"></app-video-element>
      <app-picture *ngIf="isImage(item)" [data]="item.media.value.image"></app-picture>
    </div>

    <h3 class="spot-panel__item-title" *ngIf="item.title?.value">{{ item.title.value }}</h3>

    <div class="spot-panel__item-description rte" *ngIf="item.description?.value" [innerHTML]="item.description.value"></div>

    <span class="spot-panel__item-date" *ngIf="item.date?.value">{{ item.date.value }}</span>

    <app-button class="spot-panel__item-link" *ngIf="item.link?.value" [withArrow]="false" [data]="item.link.value"></app-button>
  </div>
</div>


